export default function setters(value: any, setter: (val: any) => void) {
  return {
    value,
    onChange: (e: any) => setter(e.target.value),
  }
}
